import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { Driver, CreateDriverRequest } from '../types';

export const driverService = {
  getAll: async (): Promise<Driver[]> => {
    const response = await apiClient.get<Driver[]>(API_ENDPOINTS.DRIVERS.BASE);
    return response.data;
  },

  getActive: async (): Promise<Driver[]> => {
    const response = await apiClient.get<Driver[]>(API_ENDPOINTS.DRIVERS.ACTIVE);
    return response.data;
  },

  getById: async (id: number): Promise<Driver> => {
    const response = await apiClient.get<Driver>(API_ENDPOINTS.DRIVERS.BY_ID(id));
    return response.data;
  },

  create: async (data: CreateDriverRequest): Promise<Driver> => {
    const response = await apiClient.post<Driver>(API_ENDPOINTS.DRIVERS.BASE, data);
    return response.data;
  },

  update: async (id: number, data: Partial<CreateDriverRequest>): Promise<Driver> => {
    const response = await apiClient.put<Driver>(API_ENDPOINTS.DRIVERS.BY_ID(id), data);
    return response.data;
  },

  deactivate: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.DRIVERS.BY_ID(id));
  },
};
